"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareClass = exports.setSharePriceSchema = exports.sharePriceEffectiveDateSchema = exports.redemptionPriceSchema = exports.subscriptionPriceSchema = exports.sharePriceSchema = void 0;
const yup = __importStar(require("yup"));
const moment_1 = __importDefault(require("moment"));
const mystake_common_sdk_1 = require("@redbelly-tokeniser/mystake-common-sdk");
const constants_1 = require("../constants");
// Mandatory in both flows; unit funds call it the unit price, the share flow keeps "share price".
// Callers select the wording with `{ context: { isUnitRegistry: true } }`.
exports.sharePriceSchema = yup.number().when("$isUnitRegistry", ([isUnitRegistry]) => yup
    .number()
    .required(isUnitRegistry ? constants_1.UNIT_PRICE_REQUIRED : constants_1.SHARE_PRICE_REQUIRED)
    .typeError(isUnitRegistry ? constants_1.UNIT_PRICE_VALID : constants_1.SHARE_PRICE_VALID)
    .label(isUnitRegistry ? "Unit price" : "Share price")
    .min(0));
// Blank inputs arrive as "" or null; treating them as absent lets the controller default to the unit price.
const optionalPriceSchema = (invalidMessage, label) => yup
    .number()
    .transform((value, original) => (original === "" || original === null ? undefined : value))
    .typeError(invalidMessage)
    .label(label)
    .min(0)
    .optional();
exports.subscriptionPriceSchema = optionalPriceSchema(constants_1.SUBSCRIPTION_PRICE_VALID, "Subscription price");
exports.redemptionPriceSchema = optionalPriceSchema(constants_1.REDEMPTION_PRICE_VALID, "Redemption price");
exports.sharePriceEffectiveDateSchema = yup.lazy(() => {
    const now = new Date();
    return yup
        .string()
        .required(constants_1.DATE_REQUIRED)
        .typeError(constants_1.DATE_VALID)
        .test("effectiveDate", constants_1.DATE_VALID, (effectiveDate) => (0, moment_1.default)(effectiveDate).isValid() && (0, mystake_common_sdk_1.getDateYear)(effectiveDate) > 1920)
        .test("testMaxDate", constants_1.DATE_NOT_FUTURE, (effectiveDate) => new Date(effectiveDate).getTime() <= now.getTime())
        .label("Effective Date");
});
exports.setSharePriceSchema = yup.object().shape({
    sharePrice: exports.sharePriceSchema,
    subscriptionPrice: exports.subscriptionPriceSchema,
    redemptionPrice: exports.redemptionPriceSchema,
    effectiveFrom: exports.sharePriceEffectiveDateSchema,
});
exports.shareClass = yup.string().when("$isUnitRegistry", ([isUnitRegistry]) => yup
    .string()
    .typeError(isUnitRegistry ? constants_1.UNIT_CLASS_INVALID : constants_1.SHARE_CLASS_INVALID)
    .required(isUnitRegistry ? constants_1.UNIT_CLASS_REQUIRED : constants_1.SHARE_CLASS_REQUIRED)
    .label(isUnitRegistry ? "Unit Class" : "Share Class"));
//# sourceMappingURL=SetSharePriceSchema.js.map